import UndoManager from './UndoManager';
import common from '../common';
import HUD from './HUD';
import Canvas from './Canvas';
import commonGame from '../commonGame';

const _initDecoration = Symbol('_initDecoration');

export default class MyGame {
	constructor() {
		// Attributes.
		this._scene = null;
		this._decoration = null;
		this._hud = null;
		this._canvas = null;
		this._undoManager = null;

		this._tweens = new P3.utils.TWEEN.Group();
	}

	init() {
		console.assert(this._scene != null, 'Initialization failed: this._scene is null.');

		// Undo manager.
		this._undoManager = new UndoManager();

		// Decoration.
		this._decoration = new PIXI.Container();
		this[_initDecoration]();

		// HUD.
		this._hud = new HUD();
		this._hud.position = new PIXI.Point(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
		this._hud.init();

		// Canvas.
		// - Initialization dependencies: HUD.
		this._canvas = new Canvas();
		this._canvas.position = new PIXI.Point(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
		this._canvas.init();

		this._scene.gameLayer.addChild(this._canvas);
		this._scene.gameLayer.addChild(this._decoration);
		this._scene.gameLayer.addChild(this._hud);

		//--add an extra overlay so the drawn / colouring is underneath the black lines--//
		let sp = new PIXI.Sprite(P3.assets.texture(commonGame.selectImage));
		sp.anchor.set(0.5);
		this._canvas.addChild(sp);
		sp.y += common.levelConfig.game_scene.outline_offset;
	}

	destroy() {
		this._tweens.removeAll();
		this._hud.destroy();
	}

	update() {
		this._tweens.update();
		this._hud.update();
		this._canvas.update();
	}

	resize() {
		this._hud.resize();
	}

	animateIn() {
		this._canvas.animateIn();
	}

	[_initDecoration]() {
		if (!common.levelConfig.game_scene.include_top_bottom) return;

		const topFlowers = new PIXI.Sprite(P3.assets.texture('leaves'));
		const offset = topFlowers.height * 0.5;

		topFlowers.anchor.set(0.5, 0.5);
		topFlowers.x = common.STAGE_WIDTH * 0.5;
		topFlowers.y = -offset;

		const botFlowers = new PIXI.Sprite(P3.assets.texture('leaves'));
		botFlowers.anchor.set(0.5, 0.5);
		botFlowers.scale.y = -1;
		botFlowers.x = common.STAGE_WIDTH * 0.5;
		botFlowers.y = common.STAGE_HEIGHT + offset;

		this._decoration.addChild(topFlowers, botFlowers);

		new P3.utils.TWEEN.Tween(topFlowers, this.tweens)
		    .to({
		        y: 0
		    }, 2000 + Math.random() * 500)
			.delay(Math.random() * 250)
		    .easing(P3.utils.TWEEN.Easing.Back.Out)
		    .start();

		new P3.utils.TWEEN.Tween(botFlowers, this.tweens)
			.to({
				y: common.STAGE_HEIGHT
			}, 2000 + Math.random() * 500)
			.delay(Math.random() * 250)
			.easing(P3.utils.TWEEN.Easing.Back.Out)
			.start();
	}

	get scene() {
		return this._scene;
	}

	set scene(value) {
		this._scene = value;
	}

	get hud() {
		return this._hud;
	}

	get canvas() {
		return this._canvas;
	}

	get undoManager() {
		return this._undoManager;
	}

	get tweens() {
		return this._tweens;
	}
}
